import 'core-js/fn/object/assign';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './Main';
import {BrowserRouter} from 'react-router-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import {Provider} from 'mobx-react';

import userStore from 'stores/userStore';
import sideBarStore from 'stores/sidebarStore';
import headerStore from 'stores/headerStore';
import alertStore from 'stores/AlertStore';
import preloaderStore from 'stores/PreloaderStore';
import topicsStore from 'stores/TopicsStore';
import examPrepHeaderStore from 'stores/examPrepHeader';
import resourcesStore from 'stores/ResourcesStore';
import mcqThemesStore from 'stores/MCQThemesStore';
import mcqQuestionsStore from 'stores/McqQuestionsStore';
import mcqSessionFiltersStore from 'stores/McqSessionFiltersStore';
import mcqSessionStore from 'stores/McqSessionStore';
import mcqPerformanceStore from 'stores/McqPerformanceStore';
import sampleContentStore from 'stores/SampleContentStore';

import 'styles';

const stores = {
  userStore,
  sideBarStore,
  headerStore,
  alertStore,
  preloaderStore,
  topicsStore,
  examPrepHeaderStore,
  resourcesStore,
  mcqThemesStore,
  mcqQuestionsStore,
  mcqSessionFiltersStore,
  mcqSessionStore,
  mcqPerformanceStore,
  sampleContentStore,
};
ReactDOM.render(
  <BrowserRouter>
    <Provider {...stores}>
      <MuiThemeProvider>
        <App />
      </MuiThemeProvider>
    </Provider>
  </BrowserRouter>,
  document.getElementById('app'));



// WEBPACK FOOTER //
// ./src/index.js